import {HStack, Icon, Show, Stack, Text} from 'platform/foundation';

import {TelephonyOutboundCall} from '@dms/api/settings';
import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

interface OutboundMobileStepsProps extends RequiredTestIdProps {
  status: TelephonyOutboundCall['status'];
  customer: string;
  direction: 'row' | 'column';
  /** White text for the dark call bar. */
  isInverted: boolean;
}

const STEP_ORDER: TelephonyOutboundCall['status'][] = [
  'ringing_user',
  'waiting_for_confirmation',
  'connecting_customer',
];

/**
 * The three legs of a call placed through the viewer's mobile: their mobile rings, they press 1,
 * the customer is dialled. Done steps carry a check, the current one is bold.
 */
export function OutboundMobileSteps(props: OutboundMobileStepsProps) {
  const currentIndex = STEP_ORDER.indexOf(props.status);

  const steps = [
    i18n.t('page.telephony.indicator.stepRinging'),
    i18n.t('page.telephony.indicator.waitingForConfirmation'),
    i18n.t('page.telephony.indicator.connectingCustomer', {customer: props.customer}),
  ];

  return (
    <Stack
      direction={props.direction}
      spacing={props.direction === 'row' ? 4 : 1}
      data-testid={suffixTestId('steps', props)}
    >
      {steps.map((label, index) => (
        <HStack key={label} spacing={1} align="center">
          <Show when={index < currentIndex}>
            <Icon
              value="navigation/check"
              size={4}
              color={props.isInverted ? 'text.white' : 'text.primary'}
            />
          </Show>
          <Text
            size="small"
            color={props.isInverted ? 'white' : 'primary'}
            alternative={index === currentIndex}
            data-testid={suffixTestId(`step-${index}`, props)}
          >
            {label}
          </Text>
        </HStack>
      ))}
    </Stack>
  );
}
